import * as Actions from "../redux/trialSession";

import { call, put, takeLatest } from "redux-saga/effects";

import { loadJSONDataFromURL } from "../../utils/helpers";

export function* loadTrials({ payload }) {
  try {
    const newInfo = yield call(
      loadJSONDataFromURL,
      `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/demoTrialData.json`
    );

    yield put(Actions.loadTrialsSuccess(newInfo));
  } catch (error) {
    yield put(Actions.trialSessionRequestFail(error));
  }
}

export function* setCurrentTrial({ payload }) {
  try {
    //null is a valid payload so code accordingly
    yield put(Actions.setCurrentTrialSuccess(payload));
  } catch (error) {
    yield put(Actions.trialSessionRequestFail(error));
  }
}

//  saga
export default function* trialDataSaga() {
  yield takeLatest(Actions.loadTrialsRequest, loadTrials);
  yield takeLatest(Actions.setCurrentTrialRequest, setCurrentTrial);
}
